(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kup-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var slideshows = document.querySelectorAll('.kup-slideshow');
    slideshows.forEach(function (show) {
      var slides = show.querySelectorAll('.kup-slide');
      var dots   = show.querySelectorAll('.kup-dot');
      if (slides.length < 2) return;

      var current = 0;

      function goTo(index) {
        slides[current].classList.remove('kup-slide--active');
        dots[current] && dots[current].classList.remove('kup-dot--active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('kup-slide--active');
        dots[current] && dots[current].classList.add('kup-dot--active');
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          clearInterval(timer);
          goTo(i);
          timer = setInterval(function () { goTo(current + 1); }, 2500);
        });
      });

      var timer = setInterval(function () { goTo(current + 1); }, 2500);

      document.addEventListener('visibilitychange', function () {
        clearInterval(timer);
        if (!document.hidden) {
          timer = setInterval(function () { goTo(current + 1); }, 2500);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-configurateur"]) return;
  try {
    
  (function () {

    /* ── État global de la commande ── */
    window.kupeefy_order = {
      gourde:             null,
      wrap:               null,
      sublimation:        false,
      effet:              null,
      effet_instructions: null,
      options:            {}
    };

    var TOTAL   = 5;
    var current = 1;

    var btnNext = document.getElementById('kup-btn-next');
    var btnBack = document.getElementById('kup-btn-back');

    /* ── Formateur monnaie ── */
    function formatMoney(cents) {
      return (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',') + ' €';
    }

    /* ── Validation Suivant selon étape ── */
    function refreshNext() {
      if (current === 1) {
        var g = window.kupeefy_order.gourde;
        btnNext.disabled = !g || !g.variantId;
      } else if (current === 2 && window.kupeefy_order.sublimation) {
        var ta = document.getElementById('kup-sublim-desc');
        var hasDesc = ta && ta.value.trim().length > 0;
        var effetOk = !isGlitkup() || !!window.kupeefy_order.effet;
        btnNext.disabled = !hasDesc || !effetOk;
      } else if (current === 3) {
        var effetsAvecInstr = ['Paillettes suspendues', 'Lave', 'Boule à neige', 'Granité'];
        var effetNeedsInstr = effetsAvecInstr.indexOf(window.kupeefy_order.effet) !== -1;
        var hasInstr = !effetNeedsInstr || (window.kupeefy_order.effet_instructions && window.kupeefy_order.effet_instructions.length > 0);
        btnNext.disabled = !window.kupeefy_order.effet || !hasInstr;
      } else if (current === 4) {
        var opts = window.kupeefy_order.options;
        var couvOk = !opts.couvercle || (opts.couvercle_detail && opts.couvercle_detail.length > 0);
        var prenOk = !opts.prenom    || (opts.prenom_valeur    && opts.prenom_valeur.length    > 0);
        btnNext.disabled = !(couvOk && prenOk);
      } else {
        btnNext.disabled = false;
      }
    }

    /* ── Récap sublimation ── */
    function updateSublimRecap() {
      var nameEl  = document.getElementById('kup-sublim-gourde-name');
      var priceEl = document.getElementById('kup-sublim-gourde-price');
      if (!nameEl || !priceEl) return;
      var g = window.kupeefy_order.gourde;
      nameEl.textContent  = g ? g.title        : '—';
      priceEl.textContent = g ? g.priceDisplay  : '—';
    }

    /* ── Récap standard (sidebar + mobile) ── */
    function updateStandardRecap() {
      var g = window.kupeefy_order.gourde;
      var w = window.kupeefy_order.wrap;

      var gName  = document.getElementById('kup-recap-gourde-name');
      var gPrice = document.getElementById('kup-recap-gourde-price');
      var wName  = document.getElementById('kup-recap-wrap-name');
      var wPrice = document.getElementById('kup-recap-wrap-price');
      var tot    = document.getElementById('kup-recap-total');
      var mobTot = document.getElementById('kup-mob-total');

      if (gName)  gName.textContent  = g ? g.title        : '—';
      if (gPrice) gPrice.textContent = g ? g.priceDisplay  : '—';

      if (wName)  wName.textContent  = w ? w.title         : 'Sans wrap';
      if (wPrice) wPrice.textContent = w ? w.priceDisplay  : 'Gratuit';

      var totalCents = (g ? parseInt(g.price, 10) : 0) + (w ? parseInt(w.price, 10) : 0);
      var totalFmt   = g ? formatMoney(totalCents) : '—';
      if (tot)    tot.textContent    = totalFmt;
      if (mobTot) mobTot.textContent = totalFmt;
    }

    /* ── Affichage sous-panneau étape 2 ── */
    function isGlitkup() {
      var g = window.kupeefy_order.gourde;
      if (!g) return false;
      return (g.title || '').toLowerCase().indexOf('glitkup') !== -1;
    }

    function isFrozeKup() {
      var g = window.kupeefy_order.gourde;
      if (!g) return false;
      return (g.title || '').toLowerCase().indexOf('frozekup') !== -1;
    }

    function isEasyKup() {
      var g = window.kupeefy_order.gourde;
      if (!g) return false;
      return (g.title || '').toLowerCase().indexOf('easykup') !== -1;
    }

    function showStep2Panel() {
      var sub = document.getElementById('kup-p2-sublim');
      var std = document.getElementById('kup-p2-standard');
      if (!sub || !std) return;
      if (window.kupeefy_order.sublimation) {
        sub.style.display = '';
        std.style.display = 'none';

        /* Effets (Boule à neige / Lave) uniquement pour GlitKup */
        var effetSection = sub.querySelector('.kup-sublim__effet-section');
        if (effetSection) {
          if (isGlitkup()) {
            effetSection.style.display = '';
          } else {
            effetSection.style.display = 'none';
            /* Réinitialiser l'effet si on passe sur une autre gourde */
            window.kupeefy_order.effet = null;
            sub.querySelectorAll('.kup-sublim-effet-card').forEach(function (c) {
              c.classList.remove('kup-effet-card--selected');
              c.setAttribute('aria-pressed', 'false');
            });
          }
        }

        updateSublimRecap();
      } else {
        sub.style.display = 'none';
        std.style.display = '';
        updateStandardRecap();
      }
    }

    /* ── Initialisation wrap "Sans wrap" par défaut ── */
    window.kupeefy_order.wrap = null;

    /* ── Récap étape 3 ── */
    function updateStep3Recap() {
      var g    = window.kupeefy_order.gourde;
      var w    = window.kupeefy_order.wrap;
      var opts = window.kupeefy_order.options;

      var set = function (id, val) { var el = document.getElementById(id); if (el) el.textContent = val; };
      var show = function (id, vis) { var el = document.getElementById(id); if (el) el.style.display = vis ? '' : 'none'; };

      set('kup-s3-gourde-name',    g ? g.title       : '—');
      set('kup-s3-gourde-price',  g ? g.priceDisplay : '—');
      set('kup-s3-wrap-name',     w ? w.title        : 'Sans wrap');
      set('kup-s3-wrap-price',    w ? w.priceDisplay : 'Gratuit');
      set('kup-s3-opt-effet-name', window.kupeefy_order.effet || '—');

      var optCouv  = opts.couvercle  || false;
      var optPren  = opts.prenom     || false;
      var couvCard = document.querySelector('.kup-option-card[data-option="couvercle"]');
      var prenCard = document.querySelector('.kup-option-card[data-option="prenom"]');
      var couvPriceCents = couvCard ? parseInt(couvCard.dataset.price, 10) : 0;
      var prenPriceCents = prenCard ? parseInt(prenCard.dataset.price, 10) : 0;
      var couvPriceDisp  = couvCard ? couvCard.dataset.priceDisplay : '';
      var prenPriceDisp  = prenCard ? prenCard.dataset.priceDisplay : '';

      show('kup-s3-opt-couvercle-row', optCouv);
      if (optCouv) set('kup-s3-opt-couvercle-price', couvPriceDisp);

      show('kup-s3-opt-prenom-row', optPren);
      if (optPren) set('kup-s3-opt-prenom-price', prenPriceDisp);

      var totalCents = (g ? parseInt(g.price, 10) : 0)
                     + (w ? parseInt(w.price, 10) : 0)
                     + (optCouv ? couvPriceCents : 0)
                     + (optPren ? prenPriceCents  : 0);
      var totalFmt = g ? formatMoney(totalCents) : '—';
      set('kup-s3-total',     totalFmt);
      set('kup-mob-total-s3', totalFmt);
    }

    /* ── Visibilité option couvercle (CrazyKup uniquement) ── */
    function updateCouvercleVisibility() {
      var couvCard = document.querySelector('.kup-option-card[data-option="couvercle"]');
      if (!couvCard) return;
      var g = window.kupeefy_order.gourde;
      var titleLc = g && g.title ? g.title.toLowerCase() : '';
      var isCrazyKup = titleLc.indexOf('crazykup') !== -1 || titleLc.indexOf('icekup') !== -1 || titleLc.indexOf('frozekup') !== -1;
      couvCard.style.display = isCrazyKup ? '' : 'none';
      if (!isCrazyKup) {
        window.kupeefy_order.options.couvercle        = false;
        window.kupeefy_order.options.couvercle_detail = null;
        var togNon = couvCard.querySelector('.kup-tog[data-val="false"]');
        var togOui = couvCard.querySelector('.kup-tog--yes');
        if (togNon) togNon.classList.add('kup-tog--active');
        if (togOui) togOui.classList.remove('kup-tog--active');
        var detailWrap = document.getElementById('kup-couvercle-detail-wrap');
        if (detailWrap) detailWrap.style.display = 'none';
        var detailTa = document.getElementById('kup-couvercle-detail');
        if (detailTa) detailTa.value = '';
      }
    }
    updateCouvercleVisibility();

    /* ── Prix prénom offert pour EasyKup ── */
    var _prenomOrigPrice   = '{{ prenom_price_cents }}';
    var _prenomOrigDisplay = '+{{ section.settings.option_prenom_price }}€';
    function updatePrenomPricing() {
      var prenCard = document.querySelector('.kup-option-card[data-option="prenom"]');
      if (!prenCard) return;
      var priceSpan = prenCard.querySelector('.kup-tog--yes .kup-tog__price');
      if (isEasyKup()) {
        prenCard.dataset.price        = '0';
        prenCard.dataset.priceDisplay = 'Offert ✓';
        if (priceSpan) priceSpan.textContent = 'Offert ✓';
      } else {
        prenCard.dataset.price        = _prenomOrigPrice;
        prenCard.dataset.priceDisplay = _prenomOrigDisplay;
        if (priceSpan) priceSpan.textContent = _prenomOrigDisplay;
      }
    }
    updatePrenomPricing();

    /* ── Sélection de gourde ── */
    var cards = document.querySelectorAll('.kup-gourde-card');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          c.classList.remove('kup-gourde-card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('kup-gourde-card--selected');
        card.setAttribute('aria-pressed', 'true');

        var variantsData = card.dataset.variants ? JSON.parse(card.dataset.variants) : null;
        window.kupeefy_order.gourde = {
          id:           card.dataset.productId,
          variantId:    variantsData ? null : card.dataset.variantId,
          image:        card.dataset.productImage,
          handle:       card.dataset.productHandle,
          title:        card.dataset.productTitle,
          price:        card.dataset.productPrice,
          priceDisplay: card.dataset.productPriceDisplay
        };
        window.kupeefy_order.sublimation        = card.dataset.sublimation === 'true';
        window.kupeefy_order.effet              = null;
        var imgWrap = card.querySelector('[data-slides]');
        if (imgWrap && imgWrap._resetSlide) imgWrap._resetSlide();
        window.kupeefy_order.effet_instructions = null;
        var instrWrap = document.getElementById('kup-effet-instructions-wrap');
        var instrTa   = document.getElementById('kup-effet-instructions');
        var instrCh   = document.getElementById('kup-effet-chars');
        if (instrWrap) instrWrap.style.display = 'none';
        if (instrTa)   instrTa.value = '';
        if (instrCh)   instrCh.textContent = '0';

        var formatPicker = document.getElementById('kup-format-picker');
        var formatBtns   = document.getElementById('kup-format-btns');
        if (variantsData && variantsData.length > 1 && formatPicker && formatBtns) {
          formatBtns.innerHTML = '';
          variantsData.forEach(function (v) {
            var fbtn = document.createElement('button');
            fbtn.className = 'kup-format-btn';
            fbtn.type = 'button';
            fbtn.innerHTML = '<span class="kup-format-btn__title">' + v.title + '</span><span class="kup-format-btn__price">' + v.priceDisplay + '</span>';
            fbtn.addEventListener('click', function () {
              formatBtns.querySelectorAll('.kup-format-btn').forEach(function (b) {
                b.classList.remove('kup-format-btn--selected');
              });
              fbtn.classList.add('kup-format-btn--selected');
              window.kupeefy_order.gourde.variantId    = String(v.id);
              window.kupeefy_order.gourde.price        = String(v.price);
              window.kupeefy_order.gourde.priceDisplay = v.priceDisplay;
              refreshNext();
            });
            formatBtns.appendChild(fbtn);
          });
          var pickerLabel = formatPicker.querySelector('.kup-format-picker__label');
          if (pickerLabel) pickerLabel.textContent = (isFrozeKup() || isEasyKup()) ? 'Choisis ta couleur :' : 'Choisis ton format :';
          card.parentNode.insertBefore(formatPicker, card.nextSibling);
          formatPicker.style.display = '';
        } else {
          if (formatPicker) formatPicker.style.display = 'none';
        }

        applyProgressMode();
        updateCouvercleVisibility();
        updatePrenomPricing();
        refreshNext();
      });
    });

    /* ── Sélection + filtres wraps ── */
    function initWrapsUI() {
      var wrapCards = document.querySelectorAll('.kup-wrap-card');
      wrapCards.forEach(function (wc) {
        wc.addEventListener('click', function () {
          wrapCards.forEach(function (c) {
            c.classList.remove('kup-wrap-card--selected');
            c.setAttribute('aria-pressed', 'false');
          });
          wc.classList.add('kup-wrap-card--selected');
          wc.setAttribute('aria-pressed', 'true');

          if (wc.dataset.wrapId === 'none') {
            window.kupeefy_order.wrap = null;
          } else {
            window.kupeefy_order.wrap = {
              id:        wc.dataset.wrapId,
              variantId: wc.dataset.wrapVariantId,
              title:        wc.dataset.wrapTitle,
              price:        wc.dataset.wrapPrice,
              priceDisplay: wc.dataset.wrapPriceDisplay
            };
          }
          updateStandardRecap();
        });
      });

      var wPills = document.querySelectorAll('.kup-wpill');
      wPills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          wPills.forEach(function (p) { p.classList.remove('kup-wpill--active'); });
          pill.classList.add('kup-wpill--active');
          var filter = pill.dataset.filter;
          wrapCards.forEach(function (wc) {
            if (filter === 'all') {
              wc.classList.remove('kup-wrap-card--hidden');
            } else {
              var tags = (wc.dataset.tags || '') + ' all';
              if (tags.split(' ').includes(filter)) {
                wc.classList.remove('kup-wrap-card--hidden');
              } else {
                wc.classList.add('kup-wrap-card--hidden');
              }
            }
          });
        });
      });
    }

    var wrapGrid = document.getElementById('kup-wrap-grid');
    var wpillsWrap = document.getElementById('kup-wpills');
    var wrapsSectionId = wrapGrid ? wrapGrid.dataset.sectionId : null;
    var wrapsTotalPages = wrapGrid ? parseInt(wrapGrid.dataset.totalPages || '1', 10) : 1;

    function sortWrapFilters() {
      if (!wpillsWrap) return;
      var toutBtn = wpillsWrap.querySelector('[data-filter="all"]');
      var others = Array.from(wpillsWrap.querySelectorAll('.kup-wpill:not([data-filter="all"])'));
      others.sort(function (a, b) {
        return a.textContent.trim().localeCompare(b.textContent.trim(), 'fr', { sensitivity: 'base', numeric: true });
      });
      while (wpillsWrap.firstChild) wpillsWrap.removeChild(wpillsWrap.firstChild);
      if (toutBtn) wpillsWrap.appendChild(toutBtn);
      others.forEach(function (btn) { wpillsWrap.appendChild(btn); });
    }

    function sortWrapCards() {
      if (!wrapGrid) return;
      var noneCard = wrapGrid.querySelector('.kup-wrap-card--none');
      var others = Array.from(wrapGrid.querySelectorAll('.kup-wrap-card:not(.kup-wrap-card--none)'));
      others.sort(function (a, b) {
        var la = (a.dataset.category || '').trim();
        var lb = (b.dataset.category || '').trim();
        return la.localeCompare(lb, 'fr', { sensitivity: 'base', numeric: true });
      });
      while (wrapGrid.firstChild) wrapGrid.removeChild(wrapGrid.firstChild);
      if (noneCard) wrapGrid.appendChild(noneCard);
      others.forEach(function (card) { wrapGrid.appendChild(card); });
    }

    if (wrapGrid && wrapsSectionId && wrapsTotalPages > 1) {
      var knownWrapFilters = function () {
        return Array.from(document.querySelectorAll('.kup-wpill')).map(function (b) { return b.dataset.filter; });
      };
      var mergeWrapsPage = function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        temp.querySelectorAll('#kup-wrap-grid .kup-wrap-card:not(.kup-wrap-card--none)').forEach(function (card) {
          wrapGrid.appendChild(card);
        });

        if (wpillsWrap) {
          var known = knownWrapFilters();
          temp.querySelectorAll('.kup-wpill[data-filter]').forEach(function (btn) {
            if (btn.dataset.filter !== 'all' && known.indexOf(btn.dataset.filter) === -1) {
              wpillsWrap.appendChild(btn);
              known.push(btn.dataset.filter);
            }
          });
        }
      };
      var fetchWrapsPage = function (page) {
        var url = window.location.pathname + '?page=' + page + '&section_id=' + wrapsSectionId;
        return fetch(url).then(function (res) { return res.text(); }).then(mergeWrapsPage);
      };

      var wrapsChain = Promise.resolve();
      for (var wp = 2; wp <= wrapsTotalPages; wp++) {
        (function (page) {
          wrapsChain = wrapsChain.then(function () { return fetchWrapsPage(page); });
        })(wp);
      }
      wrapsChain.then(sortWrapCards).then(sortWrapFilters).then(initWrapsUI).catch(initWrapsUI);
    } else {
      sortWrapCards();
      sortWrapFilters();
      initWrapsUI();
    }

    /* ── Textarea sublimation ── */
    var sublimTextarea = document.getElementById('kup-sublim-desc');
    var sublimChars    = document.getElementById('kup-sublim-chars');
    if (sublimTextarea) {
      sublimTextarea.addEventListener('input', function () {
        var val = sublimTextarea.value;
        if (sublimChars) sublimChars.textContent = val.length;
        window.kupeefy_order.description_sublimation = val.trim();
        if (val.trim().length > 0) {
          sublimTextarea.classList.remove('kup-sublim__textarea--error');
        }
        refreshNext();
      });
    }

    /* ── Navigation entre étapes ── */
    function goTo(step) {
      var animIn = step >= current
        ? 'kup-slide-from-right 280ms ease both'
        : 'kup-slide-from-left 280ms ease both';
      for (var i = 1; i <= TOTAL; i++) {
        var panel = document.getElementById('kup-panel-' + i);
        if (!panel) continue;
        if (i === step) {
          panel.classList.remove('kup-panel--hidden');
          panel.style.animation = 'none';
          panel.offsetHeight;
          panel.style.animation = animIn;
        } else {
          panel.classList.add('kup-panel--hidden');
        }
      }

      for (var j = 1; j <= TOTAL; j++) {
        var item = document.getElementById('kup-step-item-' + j);
        if (!item) continue;
        item.classList.remove('kup-step-item--active', 'kup-step-item--done');
        item.setAttribute('aria-current', 'false');
        if (j < step)      { item.classList.add('kup-step-item--done'); }
        else if (j === step) { item.classList.add('kup-step-item--active'); item.setAttribute('aria-current', 'step'); }
      }

      for (var k = 1; k < TOTAL; k++) {
        var line = document.getElementById('kup-line-' + k);
        if (!line) continue;
        if (k < step) { line.classList.add('kup-step-line--done'); }
        else           { line.classList.remove('kup-step-line--done'); }
      }

      btnBack.style.visibility = step === 1 ? 'hidden' : 'visible';
      btnNext.textContent   = 'Suivant →';
      btnNext.style.display = step === TOTAL ? 'none' : '';
      current = step;
      window.scrollTo({ top: 0, behavior: 'smooth' });

      if (step === 2) showStep2Panel();
      if (step === 4) {
        updateStep3Recap();
        // Mobile: scroll so the sticker prénom card is visible above the fixed bars
        if (window.innerWidth <= 759) {
          setTimeout(function () {
            var prenCard = document.querySelector('.kup-option-card[data-option="prenom"]');
            if (!prenCard) return;
            var rect = prenCard.getBoundingClientRect();
            var safeLine = window.innerHeight - 130;
            if (rect.bottom > safeLine) {
              window.scrollBy(0, rect.bottom - safeLine + 16);
            }
          }, 320);
        }
      }
      if (step === 5) buildFinalRecap();

      if (window.kupeefy_order.sublimation) updateSublimProgress(step);

      refreshNext();
    }

    /* ── Étape 4 : Récapitulatif + panier ── */
    function buildFinalRecap() {
      var container = document.getElementById('kup-final-recap');
      if (!container) return;

      var g    = window.kupeefy_order.gourde;
      var w    = window.kupeefy_order.wrap;
      var opts = window.kupeefy_order.options;
      var isSublim = window.kupeefy_order.sublimation;

      var couvCard = document.querySelector('.kup-option-card[data-option="couvercle"]');
      var prenCard = document.querySelector('.kup-option-card[data-option="prenom"]');
      var couvPriceCents = (opts.couvercle && couvCard) ? parseInt(couvCard.dataset.price, 10) : 0;
      var prenPriceCents = (opts.prenom    && prenCard) ? parseInt(prenCard.dataset.price, 10) : 0;

      var html = '';

      /* Gourde */
      html += '<div class="kup-final-row">';
      if (g && g.image) html += '<img src="' + g.image + '" class="kup-final-thumb" alt="">';
      html += '<div class="kup-final-row-info"><span class="kup-final-row-name">' + (g ? g.title : '—') + '</span><span class="kup-final-row-label">Gourde</span></div>';
      html += '<span class="kup-final-row-price">' + (g ? g.priceDisplay : '—') + '</span></div>';

      /* Wrap (non affiché pour les sublimations) */
      if (!isSublim) {
        html += '<div class="kup-final-row">';
        html += '<div class="kup-final-row-info"><span class="kup-final-row-name">' + (w ? w.title : 'Sans wrap') + '</span><span class="kup-final-row-label">Wrap</span></div>';
        html += '<span class="kup-final-row-price">' + (w ? w.priceDisplay : 'Gratuit') + '</span></div>';
      }

      /* Sublimation */
      if (isSublim && window.kupeefy_order.description_sublimation) {
        html += '<div class="kup-final-sublim">';
        html += '<p class="kup-final-sublim__label">Ta description</p>';
        html += '<p class="kup-final-sublim__text">&laquo;&nbsp;' + window.kupeefy_order.description_sublimation + '&nbsp;&raquo;</p>';
        html += '<p class="kup-final-sublim__mail">📸 Photo à envoyer à <a href="mailto:kupeefy@gmail.com">kupeefy@gmail.com</a> avec ton numéro de commande</p>';
        html += '</div>';
      }

      /* Couvercle */
      if (opts.couvercle && couvCard) {
        html += '<div class="kup-final-row">';
        html += '<div class="kup-final-row-info"><span class="kup-final-row-name">Couvercle personnalisé</span>';
        if (opts.couvercle_detail) html += '<span class="kup-final-row-label">&laquo;&nbsp;' + opts.couvercle_detail + '&nbsp;&raquo;</span>';
        html += '</div><span class="kup-final-row-price">' + couvCard.dataset.priceDisplay + '</span></div>';
      }

      /* Sticker prénom */
      if (opts.prenom && prenCard) {
        html += '<div class="kup-final-row">';
        html += '<div class="kup-final-row-info"><span class="kup-final-row-name">Sticker prénom</span>';
        if (opts.prenom_valeur) html += '<span class="kup-final-row-label">&laquo;&nbsp;' + opts.prenom_valeur + '&nbsp;&raquo;</span>';
        html += '</div><span class="kup-final-row-price">' + prenCard.dataset.priceDisplay + '</span></div>';
      }

      /* Effet */
      if (window.kupeefy_order.effet) {
        html += '<div class="kup-final-row">';
        html += '<div class="kup-final-row-info">';
        html += '<span class="kup-final-row-name">' + window.kupeefy_order.effet + '</span>';
        html += '<span class="kup-final-row-label">Effet</span>';
        if (window.kupeefy_order.effet_instructions) {
          html += '<span class="kup-final-row-label" style="font-style:italic;color:#3D3A35;">&laquo;&nbsp;' + window.kupeefy_order.effet_instructions + '&nbsp;&raquo;</span>';
        }
        html += '</div>';
        html += '<span class="kup-final-row-price" style="color:#3A9B8A;">Offert</span></div>';
      }

      /* Total */
      var totalCents = (g ? parseInt(g.price, 10) : 0) + (w ? parseInt(w.price, 10) : 0) + couvPriceCents + prenPriceCents;
      html += '<div class="kup-final-divider"></div>';
      html += '<div class="kup-final-total"><span>Total estimé</span><strong>' + (g ? formatMoney(totalCents) : '—') + '</strong></div>';

      container.innerHTML = html;

      /* Bouton panier */
      var btn     = document.getElementById('kup-cart-btn');
      var btnLbl  = document.getElementById('kup-cart-btn-label');
      var spinner = document.getElementById('kup-cart-spinner');
      var errorEl = document.getElementById('kup-cart-error');

      if (btn && !btn._kupBound) {
        btn._kupBound = true;
        btn.addEventListener('click', function () {
          if (!g || !g.variantId) return;

          btn.disabled = true;
          if (btnLbl) btnLbl.textContent = 'Ajout en cours…';
          if (spinner) spinner.style.display = 'inline-block';
          if (errorEl) errorEl.style.display = 'none';

          var properties = {};
          if (!window.kupeefy_order.sublimation) {
            properties['_wrap'] = w ? w.title : 'Sans wrap';
          }
          if (opts.couvercle) properties['_couvercle'] = opts.couvercle_detail || 'Oui';
          if (opts.prenom)    properties['_prenom']    = opts.prenom_valeur    || 'Oui';
          if (window.kupeefy_order.sublimation && window.kupeefy_order.description_sublimation) {
            properties['_sublimation'] = window.kupeefy_order.description_sublimation;
          }
          if (window.kupeefy_order.effet) {
            properties['_effet'] = window.kupeefy_order.effet;
            if (window.kupeefy_order.effet_instructions) {
              properties['_effet_instructions'] = window.kupeefy_order.effet_instructions;
            }
          }

          var items = [{
            id: parseInt(g.variantId, 10),
            quantity: 1,
            properties: properties
          }];

          if (w && w.variantId) {
            items.push({ id: parseInt(w.variantId, 10), quantity: 1, properties: { '_pour_gourde': g.title } });
          }

          var optVariants = (window.kupeefy_option_variants || {});
          if (opts.couvercle && optVariants.couvercle) {
            items.push({
              id: parseInt(optVariants.couvercle, 10),
              quantity: 1,
              properties: { '_detail': opts.couvercle_detail || '', '_pour_gourde': g.title }
            });
          }
          if (opts.prenom && optVariants.prenom) {
            items.push({
              id: parseInt(optVariants.prenom, 10),
              quantity: 1,
              properties: { '_prenom_valeur': opts.prenom_valeur || '', '_pour_gourde': g.title }
            });
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Erreur inconnue'); });
            return res.json();
          })
          .then(function () {
            if (spinner) spinner.style.display = 'none';
            if (btnLbl) btnLbl.innerHTML = '<span aria-hidden="true">✓</span>&nbsp; Ajouté !';
            btn.style.background = '#3A9B8A';
            btn.style.boxShadow = '0 4px 18px rgba(58,155,138,0.35)';
            var cartBubble = document.querySelector('.cart-count-bubble');
            if (cartBubble) {
              cartBubble.style.animation = 'none';
              cartBubble.offsetHeight;
              cartBubble.style.animation = 'kup-bounce 500ms ease';
            }
            setTimeout(function () { window.location.href = '/cart'; }, 800);
          })
          .catch(function (err) {
            btn.disabled = false;
            if (btnLbl) btnLbl.textContent = '🛒  Ajouter au panier';
            if (spinner) spinner.style.display = 'none';
            if (errorEl) {
              errorEl.textContent = 'Une erreur est survenue : ' + err.message + '. Réessaie ou contacte-nous à kupeefy@gmail.com.';
              errorEl.style.display = 'block';
            }
          });
        });
      }
    }

    /* ── Toggles options étape 3 ── */
    document.querySelectorAll('.kup-option-card').forEach(function (card) {
      var optKey   = card.dataset.option;
      var toggBtns = card.querySelectorAll('.kup-tog');
      var detail   = card.querySelector('.kup-option-detail');

      if (!window.kupeefy_order.options[optKey]) {
        window.kupeefy_order.options[optKey] = false;
      }

      toggBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var isYes = btn.dataset.val === 'true';

          toggBtns.forEach(function (b) { b.classList.remove('kup-tog--active'); });
          btn.classList.add('kup-tog--active');

          window.kupeefy_order.options[optKey] = isYes;

          if (detail) detail.style.display = isYes ? 'block' : 'none';
          card.classList.toggle('kup-option-card--active', isYes);

          updateStep3Recap();
          refreshNext();
        });
      });

      var detailInput = card.querySelector('#kup-couvercle-detail');
      if (detailInput) {
        detailInput.addEventListener('input', function () {
          window.kupeefy_order.options.couvercle_detail = detailInput.value.trim();
          refreshNext();
        });
      }

      var prenInput = card.querySelector('#kup-prenom-val');
      if (prenInput) {
        prenInput.addEventListener('input', function () {
          window.kupeefy_order.options.prenom_valeur = prenInput.value.trim();
          refreshNext();
        });
      }
    });

    function applyProgressMode() {
      var isSublim = window.kupeefy_order.sublimation;
      var stdBar    = document.getElementById('kup-progress-standard');
      var sublimBar = document.getElementById('kup-progress-sublim');
      if (stdBar)    stdBar.style.display    = isSublim ? 'none' : 'flex';
      if (sublimBar) sublimBar.style.display = isSublim ? 'flex' : 'none';

      var froze = isFrozeKup() || isEasyKup();
      var effetItem = document.getElementById('kup-step-item-3');
      var effetLine = document.getElementById('kup-line-3');
      if (effetItem) effetItem.style.display = froze ? 'none' : '';
      if (effetLine) effetLine.style.display = froze ? 'none' : '';
    }

    function updateSublimProgress(panel) {
      /* Mapping panneau → étape sublimation : 1→1, 2→2, 5→3 */
      var sublimStep = panel === 1 ? 1 : panel === 2 ? 2 : 3;
      for (var i = 1; i <= 3; i++) {
        var sItem = document.getElementById('kup-s-item-' + i);
        var sLine = document.getElementById('kup-s-line-' + i);
        if (!sItem) continue;
        sItem.classList.remove('kup-step-item--active', 'kup-step-item--done');
        sItem.setAttribute('aria-current', 'false');
        if (i < sublimStep)      { sItem.classList.add('kup-step-item--done'); }
        else if (i === sublimStep) { sItem.classList.add('kup-step-item--active'); sItem.setAttribute('aria-current', 'step'); }
        if (sLine) {
          if (i < sublimStep) sLine.classList.add('kup-step-line--done');
          else                sLine.classList.remove('kup-step-line--done');
        }
      }
    }

    /* ── Sélection effet (étape 3, non-sublimation) ── */
    var effetCards = document.querySelectorAll('#kup-effet-grid .kup-effet-card');
    effetCards.forEach(function (ec) {
      ec.addEventListener('click', function () {
        effetCards.forEach(function (c) {
          c.classList.remove('kup-effet-card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        ec.classList.add('kup-effet-card--selected');
        ec.setAttribute('aria-pressed', 'true');
        window.kupeefy_order.effet = ec.dataset.effet;

        var effetsAvecInstructions = ['Paillettes suspendues', 'Lave', 'Boule à neige', 'Granité'];
        var needsInstr = effetsAvecInstructions.indexOf(window.kupeefy_order.effet) !== -1;
        var instrWrap = document.getElementById('kup-effet-instructions-wrap');
        var instrTa   = document.getElementById('kup-effet-instructions');
        var instrCh   = document.getElementById('kup-effet-chars');
        if (instrWrap) instrWrap.style.display = needsInstr ? 'block' : 'none';
        if (!needsInstr) {
          window.kupeefy_order.effet_instructions = null;
          if (instrTa)  instrTa.value = '';
          if (instrCh)  instrCh.textContent = '0';
        } else if (instrTa) {
          window.scrollTo({ top: document.documentElement.scrollHeight / 3 });
        }
        refreshNext();
      });
    });

    /* ── Textarea instructions effet ── */
    var effetInstrTa = document.getElementById('kup-effet-instructions');
    var effetInstrCh = document.getElementById('kup-effet-chars');
    if (effetInstrTa) {
      effetInstrTa.addEventListener('input', function () {
        var val = effetInstrTa.value;
        if (effetInstrCh) effetInstrCh.textContent = val.length;
        window.kupeefy_order.effet_instructions = val.trim();
        refreshNext();
      });
    }

    /* ── Sélection effet (étape 2 sublimation) ── */
    var sublimEffetCards = document.querySelectorAll('.kup-sublim-effet-card');
    sublimEffetCards.forEach(function (ec) {
      ec.addEventListener('click', function () {
        sublimEffetCards.forEach(function (c) {
          c.classList.remove('kup-effet-card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        ec.classList.add('kup-effet-card--selected');
        ec.setAttribute('aria-pressed', 'true');
        window.kupeefy_order.effet = ec.dataset.effet;
        refreshNext();
      });
    });

    btnNext.addEventListener('click', function () {
      if (!btnNext.disabled && current < TOTAL) {
        var next = current + 1;
        if (window.kupeefy_order.sublimation && (next === 3 || next === 4)) next = 5;
        if ((isFrozeKup() || isEasyKup()) && next === 3) next = 4;
        goTo(next);
      }
    });

    btnBack.addEventListener('click', function () {
      if (current > 1) {
        var prev = current - 1;
        if (window.kupeefy_order.sublimation && (prev === 3 || prev === 4)) prev = 2;
        if ((isFrozeKup() || isEasyKup()) && prev === 3) prev = 2;
        goTo(prev);
      }
    });

    /* ── Slider photos gourde : change le src de l'img existante, sans toucher au layout ── */
    document.querySelectorAll('[data-slides]').forEach(function (wrap) {
      var slides = JSON.parse(wrap.dataset.slides);
      var img    = wrap.querySelector('img');
      if (!img || slides.length < 2) return;
      var dots   = wrap.querySelectorAll('.kup-gslide-dot');
      var cur    = 0;

      function go(n) {
        cur = (n + slides.length) % slides.length;
        img.src = slides[cur];
        img.removeAttribute('srcset');
        dots.forEach(function (d, i) {
          d.classList.toggle('kup-gslide-dot--on', i === cur);
        });
      }

      wrap._resetSlide = function() { go(0); };

      wrap.querySelector('.kup-gslide-btn--prev').addEventListener('click', function (e) {
        e.stopPropagation(); go(cur - 1);
      });
      wrap.querySelector('.kup-gslide-btn--next').addEventListener('click', function (e) {
        e.stopPropagation(); go(cur + 1);
      });

      var tx = 0;
      wrap.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) { e.stopPropagation(); go(cur + (dx < 0 ? 1 : -1)); }
      });
    });

    goTo(1);

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-gourdes"]) return;
  try {
    
  document.querySelectorAll('[data-slides]').forEach(function (wrap) {
    var slides = JSON.parse(wrap.dataset.slides);
    var img    = wrap.querySelector('img');
    if (!img || slides.length < 2) return;
    var dots   = wrap.querySelectorAll('.kup-gslide-dot');
    var cur    = 0;

    function go(n) {
      cur = (n + slides.length) % slides.length;
      img.src = slides[cur];
      img.removeAttribute('srcset');
      dots.forEach(function (d, i) {
        d.classList.toggle('kup-gslide-dot--on', i === cur);
      });
    }

    wrap.querySelector('.kup-gslide-btn--prev').addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault(); go(cur - 1);
    });
    wrap.querySelector('.kup-gslide-btn--next').addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault(); go(cur + 1);
    });

    var tx = 0;
    wrap.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-wraps"]) return;
  try {
    
  (function () {
    const grid = document.getElementById('wrap-grid');
    const filtersWrap = document.querySelector('.wrap-filters');
    const emptyMsg = document.getElementById('wrap-empty');

    function bindFilters() {
      const filterBtns = document.querySelectorAll('.wrap-filter-btn');
      const cards = document.querySelectorAll('.wrap-card');

      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filterBtns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');

          const filter = btn.dataset.filter;
          let visible = 0;

          cards.forEach(function (card) {
            const tags = card.dataset.tags || '';
            if (filter === 'all' || tags.split(' ').includes(filter)) {
              card.classList.remove('wrap-card--hidden');
              visible++;
            } else {
              card.classList.add('wrap-card--hidden');
            }
          });

          if (emptyMsg) emptyMsg.style.display = visible === 0 ? 'block' : 'none';
        });
      });
    }

    if (!grid) return;

    function sortCards() {
      var cards = Array.from(grid.querySelectorAll('.wrap-card'));
      cards.sort(function (a, b) {
        var la = (a.dataset.sortLabel || '').trim();
        var lb = (b.dataset.sortLabel || '').trim();
        return la.localeCompare(lb, 'fr', { sensitivity: 'base', numeric: true });
      });
      cards.forEach(function (card) { grid.appendChild(card); });
    }

    function sortFilters() {
      var toutBtn = filtersWrap.querySelector('[data-filter="all"]');
      var otherBtns = Array.from(filtersWrap.querySelectorAll('.wrap-filter-btn:not([data-filter="all"])'));
      otherBtns.sort(function (a, b) {
        return a.textContent.trim().localeCompare(b.textContent.trim(), 'fr', { sensitivity: 'base', numeric: true });
      });
      while (filtersWrap.firstChild) filtersWrap.removeChild(filtersWrap.firstChild);
      if (toutBtn) filtersWrap.appendChild(toutBtn);
      otherBtns.forEach(function (btn) { filtersWrap.appendChild(btn); });
    }

    const sectionId = grid.dataset.sectionId;
    const totalPages = parseInt(grid.dataset.totalPages || '1', 10);

    if (!sectionId || totalPages <= 1) {
      sortCards();
      sortFilters();
      bindFilters();
      return;
    }

    function knownFilters() {
      return Array.from(document.querySelectorAll('.wrap-filter-btn')).map(function (b) { return b.dataset.filter; });
    }

    function mergePage(html) {
      const temp = document.createElement('div');
      temp.innerHTML = html;

      temp.querySelectorAll('.wrap-card').forEach(function (card) {
        grid.appendChild(card);
      });

      const known = knownFilters();
      temp.querySelectorAll('.wrap-filter-btn[data-filter]').forEach(function (btn) {
        if (btn.dataset.filter !== 'all' && known.indexOf(btn.dataset.filter) === -1) {
          filtersWrap.appendChild(btn);
          known.push(btn.dataset.filter);
        }
      });
    }

    function fetchPage(page) {
      const url = window.location.pathname + '?page=' + page + '&section_id=' + sectionId;
      return fetch(url).then(function (res) { return res.text(); }).then(mergePage);
    }

    let chain = Promise.resolve();
    for (let p = 2; p <= totalPages; p++) {
      chain = chain.then(function () { return fetchPage(p); });
    }
    chain.then(sortCards).then(sortFilters).then(bindFilters).catch(bindFilters);
  })();

  } catch(e) { console.error(e); }
})();
})();
